#import "../../DepartmentGroupFields.graphql"
mutation DepartmentGroupCreate($input: DepartmentGroupCreateInput!) {
  departmentGroupCreate(input: $input) {
    departmentGroup {
      ...DepartmentGroupFields
    }
  }
}
